var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Table',{staticClass:"selection",attrs:{"border":"","stripe":"","columns":_vm.columns,"data":_vm.selection}})}
var staticRenderFns = []

export { render, staticRenderFns }